/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mascot_Chat_LoadingInputs */

const tr_mascot_chat_loading = /** @type {(inputs: Mascot_Chat_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yükleniyor…`)
};

const en_mascot_chat_loading = /** @type {(inputs: Mascot_Chat_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading…`)
};

const de_mascot_chat_loading = /** @type {(inputs: Mascot_Chat_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird geladen…`)
};

const ru_mascot_chat_loading = /** @type {(inputs: Mascot_Chat_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Загрузка…`)
};

/**
* | output |
* | --- |
* | "Loading…" |
*
* @param {Mascot_Chat_LoadingInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mascot_chat_loading = /** @type {((inputs?: Mascot_Chat_LoadingInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mascot_Chat_LoadingInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mascot_chat_loading(inputs)
	if (locale === "de") return de_mascot_chat_loading(inputs)
	if (locale === "ru") return ru_mascot_chat_loading(inputs)
	return tr_mascot_chat_loading(inputs)
});